<script setup>
import { computed } from 'vue'
import { store } from '@/store/appStore.js'
import NavRail from './NavRail.vue'
import PlaceholderModule from './PlaceholderModule.vue'
import PharmacyMaster from '@/components/modules/PharmacyMaster.vue'
import OrderManagement from '@/components/modules/OrderManagement.vue'
import OrderTracking from '@/components/modules/OrderTracking.vue'
import InvoiceBilling from '@/components/modules/InvoiceBilling.vue'
import StockDashboard from '@/components/modules/StockDashboard.vue'
import OOSDashboard from '@/components/modules/OOSDashboard.vue'
import PharmacyProfile from '@/components/modules/PharmacyProfile.vue'
import CampaignView from '@/components/modules/CampaignView.vue'
import POBDashboard from '@/components/modules/POBDashboard.vue'
import BusinessPotential from '@/components/modules/BusinessPotential.vue'
import BrandPerformance from '@/components/modules/BrandPerformance.vue'
import OrderAnalytics from '@/components/modules/OrderAnalytics.vue'
import MarketResearch from '@/components/modules/MarketResearch.vue'
import MarketingDashboard from '@/components/modules/MarketingDashboard.vue'
import ProductAvailability from '@/components/modules/ProductAvailability.vue'
import Notifications from '@/components/modules/Notifications.vue'
import Reports from '@/components/modules/Reports.vue'
import ProductMaster from '@/components/modules/ProductMaster.vue'
import AdminWorkspace from '@/components/modules/AdminWorkspace.vue'
// New independent-architecture screens (Pharmacy / Sales Exec / Sales
// Supervisor / Telecaller) — see appStore.js's "NEW ARCHITECTURE" section.
import MyOrdersV2 from '@/components/modules/MyOrdersV2.vue'
import MyInvoicesV2 from '@/components/modules/MyInvoicesV2.vue'
import MyPromotionsV2 from '@/components/modules/MyPromotionsV2.vue'
import MyProfileV2 from '@/components/modules/MyProfileV2.vue'
import SEOrders from '@/components/modules/SEOrders.vue'
import SEPharmacies from '@/components/modules/SEPharmacies.vue'
import SEPob from '@/components/modules/SEPob.vue'
import SEBusinessPotential from '@/components/modules/SEBusinessPotential.vue'
import SSOrders from '@/components/modules/SSOrders.vue'
import SSPob from '@/components/modules/SSPob.vue'
import SSBusinessPotential from '@/components/modules/SSBusinessPotential.vue'
import TCOrders from '@/components/modules/TCOrders.vue'
import ApprovalFlow from '@/components/modules/ApprovalFlow.vue'
import WarehouseInventory from '@/components/modules/WarehouseInventory.vue'
import WarehouseOrders from '@/components/modules/WarehouseOrders.vue'
import SCMStock from '@/components/modules/SCMStock.vue'
import SCMOOS from '@/components/modules/SCMOOS.vue'
import CampaignManagement from '@/components/modules/CampaignManagement.vue'

const MODULE_MAP = {
  pharmacyMaster: PharmacyMaster, orderManagement: OrderManagement,
  orderTracking: OrderTracking, invoiceBilling: InvoiceBilling,
  stockDashboard: StockDashboard, oosDashboard: SCMOOS,
  pharmacyProfile: PharmacyProfile, campaignView: CampaignView,
  pobDashboard: POBDashboard, businessPotential: BusinessPotential,
  brandPerformance: BrandPerformance, orderAnalytics: OrderAnalytics,
  marketResearch: MarketResearch, marketingDashboard: MarketingDashboard,
  productAvailability: ProductAvailability, notifications: Notifications,
  reports: Reports, productMaster: ProductMaster, adminWorkspace: AdminWorkspace,
  myOrdersV2: MyOrdersV2, myInvoicesV2: MyInvoicesV2, myPromotionsV2: MyPromotionsV2, myProfileV2: MyProfileV2,
  seOrders: SEOrders, sePharmacies: SEPharmacies, sePob: SEPob, seBusinessPotential: SEBusinessPotential,
  ssOrders: SSOrders, ssPob: SSPob, ssBusinessPotential: SSBusinessPotential,
  tcOrders: TCOrders, approvalFlow: ApprovalFlow,
  warehouseInventory: WarehouseInventory, warehouseOrders: WarehouseOrders,
  scmStock: SCMStock, scmOOS: SCMOOS,
  campaignManagement: CampaignManagement,
}
const activeComponent = computed(() => MODULE_MAP[store.state.activeModule] || null)
</script>

<template>
  <div class="app-shell">
    <NavRail />
    <div class="main-area">
      <div class="top-bar">
        <h2 class="module-title">{{ store.activeModuleMeta.value?.label }}</h2>
      </div>
      <div class="content-area">
        <component v-if="activeComponent" :is="activeComponent"
                   :key="store.state.activeModule + '-' + store.state.scenario" />
        <PlaceholderModule v-else-if="store.activeModuleMeta.value" :module-meta="store.activeModuleMeta.value" />
      </div>
    </div>
  </div>
</template>